import script from "./ReviewRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewRecord.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewRecord.vue?vue&type=style&index=0&id=b7e4edfa&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e4edfa"]])

export default __exports__